import React from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import { Text, Icon } from '../../../Elements';

import classes from './SelectOption.module.scss';

const SelectOption = ({
  isSelected,
  data,
  groupStatus,
  selectAllStatus,
  counterSelectOptions,
  value,
  limit,
  allValueOptions,
  offTrendline
}) => {
  let stateGroup;
  let stateSelectAll;
  const lengthValue = value.length;
  let disabledAllSelect = false;
  let trigerCheck = true;

  const rotateDeg = {
    transform: `rotate(${180}deg)`
  };

  if (data.group !== undefined) {
    stateGroup = groupStatus[data.group];
  } else if (data.nameGroup !== undefined) {
    stateSelectAll = selectAllStatus[data.nameGroup].status;
    let count = 0;
    const selectGroup = allValueOptions.find(
      item => item.nameCat === data.nameGroup
    );

    let checkAllGroup;
    if (!offTrendline) {
      checkAllGroup = value.find(item => item.nameCat === selectGroup.nameCat);
    }

    value.forEach(item => {
      if (item.nameParent === data.nameGroup) {
        count++;
      }
    });
    if (
      count === 0 &&
      count < selectAllStatus[data.nameGroup].length &&
      checkAllGroup
    ) {
      count++;
    }
    if (
      lengthValue + (selectAllStatus[data.nameGroup].length - count) >
      limit
    ) {
      disabledAllSelect = true;
    }
  } else if (data.nameParent !== undefined) {
    const selectGroup = allValueOptions.find(
      item => item.nameCat === data.nameParent
    );
    let checkAllGroup;
    if (!offTrendline) {
      checkAllGroup = value.find(item => item.nameCat === selectGroup.nameCat);
    }
    if (checkAllGroup) {
      trigerCheck = false;
    }
  } else if (data.nameCat !== undefined) {
    let count = 0;
    value.forEach(item => {
      if (item.nameParent === data.nameCat) {
        count++;
      }
    });
    if (counterSelectOptions === limit && count === 0) {
      trigerCheck = false;
    }
  }

  return (
    <div
      className={cn(
        classes.optionWrap,
        data.openGroup !== undefined && classes.optionWrap_group,
        stateGroup && classes.optionWrap_noBorder,
        counterSelectOptions === limit &&
          !data.nameCat &&
          !data.group &&
          !isSelected &&
          !data.nameGroup &&
          trigerCheck &&
          classes.optionWrap_noCursor,
        data.nameGroup && disabledAllSelect && classes.optionWrap_noCursor,
        data.nameCat !== undefined &&
          !trigerCheck &&
          classes.optionWrap_noCursor
      )}
    >
      {data.openGroup === undefined && (
        <div
          className={cn(
            classes.checkBox,
            (isSelected || stateSelectAll) && classes.checkBox_selected
          )}
        >
          {(isSelected || stateSelectAll) && <div className={classes.arrow} />}
        </div>
      )}
      <Text
        size={4}
        className={cn(
          classes.label,
          data.openGroup !== undefined && classes.label_group,
          data.nameCat && classes.label_category,
          counterSelectOptions === limit &&
            !data.nameCat &&
            !data.group &&
            !isSelected &&
            !data.nameGroup &&
            trigerCheck &&
            classes.label_disabled,
          data.nameGroup && disabledAllSelect && classes.label_disabled,
          data.nameCat !== undefined && !trigerCheck && classes.label_disabled
        )}
      >
        {data.label}
      </Text>
      {stateGroup !== undefined && (
        <Icon
          size="24px"
          icon={'arrow'}
          color={'#3a5ba2'}
          style={stateGroup && rotateDeg}
        />
      )}
    </div>
  );
};

SelectOption.propTypes = {
  isSelected: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.object])
    .isRequired,
  checkRenderKey: PropTypes.string,
  counterSelectOptions: PropTypes.number.isRequired,
  groupStatus: PropTypes.object.isRequired,
  value: PropTypes.array.isRequired,
  limit: PropTypes.number,
  allValueOptions: PropTypes.array.isRequired,
  selectAllStatus: PropTypes.object.isRequired,
  offTrendline: PropTypes.bool
};

export default SelectOption;
